export default __webpack_public_path__ + "assets/8e8b7b917297ee36d546bc89dfd28e6e.svg";